module.exports = __webpack_public_path__ + "static/img/BD@2x.db5de285.jpg";